import React from 'react';
import BookingSystem from '../components/BookingSystem';

export default function Booking() {
  return <BookingSystem />;
}